import React from "react";
import logo from "../../assets/logo.svg";
import { Link } from "react-router-dom";
import rightArrow from "../../assets/ArrowNavBar.svg";
import mapIcon from "../../assets/mapIcon.svg";
import { NavigationBarProps } from "../../types";
import { useSidenav } from "../../hooks/useSidenav";
import { useFormSubmit } from "../../hooks/useFormSubmit";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const NavigationBar: React.FC<NavigationBarProps> = ({
  scrollTo,
  goToSelectionRef,
}: NavigationBarProps) => {
  const navigate = useNavigate();
  const {
    showForm,
    isMenuOpen,
    handleCloseMenu,
    handleOpenMenu,
    handleShowForm,
    handleHideForm,
  } = useSidenav();

  const {
    formData,
    errors,
    isSubmitting,
    form,
    handleInputChange,
    enviarEmail,
  } = useFormSubmit();

  const goToPortafolio = () => {
    scrollTo(goToSelectionRef);
  };

  const navigateToHomeAndScrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/home", { state: { scrollToTop: true } });
  };

  return (
    <>
      {/* Navbar Principal */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm">
        <div className="flex items-center justify-between px-4 py-2">
          {/* Logo */}
          <Link
            onClick={navigateToHomeAndScrollToTop}
            to="/home"
            className="flex items-center"
          >
            <img
              draggable={false}
              src={logo}
              alt="Logo"
              className="h-8 w-auto pl-5"
            />
          </Link>

          {/* Botón Hamburger */}
          <motion.button
            onClick={handleOpenMenu}
            whileHover={{ scale: 1.1, rotate: 90 }}
            whileTap={{ scale: 0.8 }}
            className="text-white p-2 rounded transition-all duration-200 hover:scale-110"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </motion.button>
        </div>
      </nav>

      {/* Sidenav */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white z-50 transform transition-transform duration-300 ease-in-out ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Botón Cerrar */}
        <button
          onClick={handleCloseMenu}
          className="absolute top-5 right-5 text-2xl font-bold text-black hover:text-gray-600 transition-colors duration-200 hover:scale-110"
        >
          ×
        </button>

        {/* Contenido del Sidenav */}
        <div className="pt-16 px-8 h-full overflow-y-auto">
          {!showForm ? (
            <>
              {/* Enlaces de Navegación */}
              <div className="space-y-4">
                <Link
                  to="/home"
                  className="flex items-center text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold transition-all duration-200 hover:scale-105 transform origin-left group"
                  onClick={handleCloseMenu}
                >
                  Inicio
                  <img
                    draggable={false}
                    src={rightArrow}
                    alt=""
                    className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  />
                </Link>

                <Link
                  to="/home/portafolio"
                  className="flex items-center text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold transition-all duration-200 hover:scale-105 transform origin-left group"
                  onClick={() => {
                    goToPortafolio();
                    handleCloseMenu();
                  }}
                >
                  Portafolio
                  <img
                    draggable={false}
                    src={rightArrow}
                    alt=""
                    className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  />
                </Link>

                <Link
                  to="/careers"
                  className="flex items-center text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold transition-all duration-200 hover:scale-105 transform origin-left group"
                  onClick={handleCloseMenu}
                >
                  Empleos
                  <img
                    draggable={false}
                    src={rightArrow}
                    alt=""
                    className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  />
                </Link>

                <Link
                  to="/about"
                  className="flex items-center text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold transition-all duration-200 hover:scale-105 transform origin-left group"
                  onClick={handleCloseMenu}
                >
                  Sobre Nosotros
                  <img
                    draggable={false}
                    src={rightArrow}
                    alt=""
                    className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  />
                </Link>

                <div className="space-y-2">
                  <button
                    onClick={handleShowForm}
                    className="flex items-center text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold transition-all duration-200 hover:scale-105 transform origin-left group"
                  >
                    Cont&aacute;ctanos
                    <img
                      draggable={false}
                      src={rightArrow}
                      alt=""
                      className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    />
                  </button>
                  <Link
                    to="https://goo.gl/maps/sHnehVLCdqHvbGyH8"
                    className="text-left py-2 px-2 text-lg text-black hover:text-blue-600 font-bold flex items-center transition-all duration-200 hover:scale-105 transform origin-left group"
                    onClick={handleCloseMenu}
                  >
                    Ubicación
                    <img
                      draggable={false}
                      src={mapIcon}
                      alt=""
                      className="w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    />
                  </Link>
                </div>
              </div>

              {/* Información de Contacto */}

              <div className="mt-8 pt-8 border-t border-gray-200">
                <div className="text-left font-inter text-sm text-gray-500 leading-5">
                  Para todas las consultas de nuevos negocios, por favor
                  contáctenos en{" "}
                  <a
                    href="mailto:comunicaciones@penadefillo.com"
                    className="text-black hover:underline"
                  >
                    comunicaciones@penadefillo.com
                  </a>{" "}
                  o a través del formulario “Contacto”.
                  <p className="mb-2">
                    Av. Gustavo M. Ricart 54 - Torre Solazar
                  </p>
                  <p className="mb-2">Santo Domingo, República Dominicana</p>
                  <p className="mb-2">Tel: (809) 549-3030</p>
                  <p className="mb-4">Email: info@penadefillo.com</p>
                </div>
              </div>
            </>
          ) : (
            /* Formulario de Contacto */
            <div className="space-y-4">
              <h3 className="text-left text-2xl font-bold mb-4">
                ¡Déjanos tus datos!
              </h3>

              <form ref={form} onSubmit={enviarEmail} className="space-y-4">
                {/* Empresa */}
                <div>
                  <input
                    type="text"
                    name="empresa"
                    placeholder="Empresa/Compañía"
                    value={formData.empresa}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:border-blue-500 outline-none transition-colors duration-200"
                  />
                </div>

                {/* Nombre */}
                <div>
                  <input
                    type="text"
                    name="nombre"
                    placeholder="Nombre *"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    className={`w-full p-2 border-b outline-none transition-colors duration-200 ${
                      errors.nombre
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.nombre && (
                    <p className="text-red-500 text-xs mt-1">{errors.nombre}</p>
                  )}
                </div>

                {/* Apellido */}
                <div>
                  <input
                    type="text"
                    name="apellido"
                    placeholder="Apellido *"
                    value={formData.apellido}
                    onChange={handleInputChange}
                    className={`w-full p-2 border-b outline-none transition-colors duration-200 ${
                      errors.apellido
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.apellido && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.apellido}
                    </p>
                  )}
                </div>

                {/* Email */}
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`w-full p-2 border-b outline-none transition-colors duration-200 ${
                      errors.email
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.email && (
                    <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                  )}
                </div>

                {/* Teléfono */}
                <div>
                  <input
                    type="tel"
                    name="telefono"
                    placeholder="Teléfono *"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    className={`w-full p-2 border-b outline-none transition-colors duration-200 ${
                      errors.telefono
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.telefono && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.telefono}
                    </p>
                  )}
                </div>

                {/* Asunto */}
                <div>
                  <input
                    type="text"
                    name="asunto"
                    placeholder="Asunto *"
                    value={formData.asunto}
                    onChange={handleInputChange}
                    className={`w-full p-2 border-b outline-none transition-colors duration-200 ${
                      errors.asunto
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.asunto && (
                    <p className="text-red-500 text-xs mt-1">{errors.asunto}</p>
                  )}
                </div>

                {/* Descripción */}
                <div>
                  <textarea
                    name="descripcion"
                    placeholder="Descripción *"
                    value={formData.descripcion}
                    onChange={handleInputChange}
                    rows={4}
                    className={`w-full p-2 border outline-none resize-none transition-colors duration-200 ${
                      errors.descripcion
                        ? "border-red-500"
                        : "border-gray-300 focus:border-blue-500"
                    }`}
                    required
                  />
                  {errors.descripcion && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.descripcion}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#222222] text-white font-semibold py-3 px-4 transition-all duration-200 hover:scale-105 transform disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "Enviando..." : "Enviar Mensaje"}
                </button>
              </form>

              {/* Botón para volver al menú */}
              <button
                onClick={handleHideForm}
                className="w-full text-gray-600 hover:text-black transition-colors duration-200 mt-4"
              >
                ← Volver al menú
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Overlay para cerrar el menú */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
          onClick={handleCloseMenu}
        />
      )}
    </>
  );
};
